import { render } from "./DigitizePage.vue?vue&type=template&id=e092fcd8"
import script from "./DigitizePage.vue?vue&type=script&lang=js"
export * from "./DigitizePage.vue?vue&type=script&lang=js"

import "./DigitizePage.vue?vue&type=style&index=0&id=e092fcd8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__